import { makeAutoObservable } from 'mobx'

import { ConsentChoices, ConsentRecord, readConsent, writeConsent } from '@/lib/consent'

class ConsentStore {
  /** null until the visitor has made a choice */
  record: ConsentRecord | null = readConsent()
  preferencesOpen = false

  constructor() {
    makeAutoObservable(this)
  }

  get decided(): boolean {
    return this.record !== null
  }

  /** Support chat (Intercom) */
  get functional(): boolean {
    return this.record?.functional ?? false
  }

  get analytics(): boolean {
    return this.record?.analytics ?? false
  }

  save(choices: ConsentChoices) {
    this.record = writeConsent(choices)
    this.preferencesOpen = false
  }

  acceptAll() {
    this.save({ functional: true, analytics: true })
  }

  rejectAll() {
    this.save({ functional: false, analytics: false })
  }

  /** Turns on one category and leaves the rest as the visitor set them (off if never asked). */
  allow(category: keyof ConsentChoices) {
    this.save({ functional: this.functional, analytics: this.analytics, [category]: true })
  }

  openPreferences() {
    this.preferencesOpen = true
  }

  closePreferences() {
    this.preferencesOpen = false
  }
}

export const consentStore = new ConsentStore()
